import React from "react";
import {buildCohortAnalyserRoute} from "./routes";
import {Query} from "../containers/HealthcareUsageReport/types/CohortQuery";

export const cohortAnalyserRoute = (query: Query | undefined, classicCohortAnalyser: boolean): string => {
    return query?.id === undefined ? '' : classicCohortAnalyser ? `/cohort-analyser-v1/${query.id}` : buildCohortAnalyserRoute(query.id)
}

export interface ProjectsPageContextType {
    classic: boolean
    setClassic: (classic: boolean) => void
}

export const ProjectsPageContext = React.createContext<ProjectsPageContextType | undefined>(undefined)